export interface ZoomSettingInit {
  enableAutoCreate: boolean;
}

export default class ZoomSetting {
  public readonly enableAutoCreate: boolean;

  constructor(init: ZoomSettingInit) {
    this.enableAutoCreate = init.enableAutoCreate;
  }
}
